import React from 'react';
import Type from 'prop-types';
import { Box, Chip } from '@material-ui/core';
import useStyles from './DateSeparator.styles';

const DateSeparator = props => {
  const { date: dateProp, formatDate } = props;
  const date = new Date(dateProp);
  const calendarDate = formatDate(date);
  const classes = useStyles();

  return (
    <Box my={2} className={classes.root}>
      <Chip label={calendarDate} variant="outlined" color="primary" />
    </Box>
  );
};

DateSeparator.propTypes = {
  date: Type.string.isRequired,
  formatDate: Type.func.isRequired,
};

export default DateSeparator;
